import { useEffect, useRef } from "react";
import { useAuth } from "../context/AuthContext";
import NotificationDropdown, { useNotificationUnreadCount } from "./NotificationDropdown";
import "./NotificationDropdown.css";

const BELL_ICON = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 01-3.46 0" />
  </svg>
);

export default function NotificationBell({
  isOpen,
  onOpenChange,
  buttonClassName = "nav-btn",
  wrapClassName = "nav-notif-wrap",
  closeOnOutsideClick = true,
}) {
  const { currentUser } = useAuth();
  const wrapRef = useRef(null);
  const unreadCount = useNotificationUnreadCount(currentUser?.uid);

  useEffect(() => {
    if (!closeOnOutsideClick || !isOpen) return undefined;

    function handleClickOutside(e) {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        onOpenChange?.(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [closeOnOutsideClick, isOpen, onOpenChange]);

  if (!currentUser) return null;

  return (
    <div className={wrapClassName} ref={wrapRef}>
      <button
        type="button"
        className={buttonClassName}
        aria-label="Notifications"
        aria-expanded={Boolean(isOpen)}
        onClick={() => onOpenChange?.(!isOpen)}
      >
        {BELL_ICON}
        {unreadCount > 0 && <span className="nav-notif-dot" aria-hidden />}
      </button>
      <NotificationDropdown isOpen={Boolean(isOpen)} onClose={() => onOpenChange?.(false)} />
    </div>
  );
}
